import { FC } from "react";

import Box from "@mui/material/Box";
import { Info } from "luxon";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { DashboardRadioGroup } from "@/dashboard-design-system/RadioGroup";

interface WeekdayListProps {
  selectedWeekday: number;
  onSelectWeekday: (weekday: number) => void;
}

export const WeekdayList: FC<WeekdayListProps> = ({ selectedWeekday, onSelectWeekday }) => {
  const { isoLocale } = useLocaleContext();
  const weekdayNames = Info.weekdays("long", { locale: isoLocale });
  const values = Object.fromEntries(weekdayNames.map((name, index) => [String(index + 1), capitalize(name)]));

  return (
    <Box sx={(theme) => ({ paddingX: theme.spacing(3) })} data-test="edit-charge-date-weekdays">
      <DashboardRadioGroup
        name="edit-charge-date-weekday"
        size="small"
        values={values}
        defaultValue={String(selectedWeekday)}
        onChange={(value) => onSelectWeekday(Number(value))}
      />
    </Box>
  );
};

const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);
